import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PictureAsPdf from "@material-ui/icons/PictureAsPdf";

import { DISABLED_GREY, COLOR_NAVY } from "../common/constants";
import Card from "../common/Card";
import Typography from "../common/Typography";

const propTypes = {
  items: PropTypes.array.isRequired,
};

const StyledTableRow = styled(TableRow)`
  cursor: pointer;
  transition: 0.15s background-color;

  :hover {
    background-color: ${DISABLED_GREY};
  }
`;

const StyledCard = styled(Card)`
  width: 90%;
  max-width: 700px;
`;

const StyledH2 = Typography.withComponent("h2").extend`
  font-size: 40px;
`;

const TableHeaderCell = styled(TableCell)`
  color: rgba(0, 0, 0, 0.54) !important;
`;

function Documents(props) {
  const openPdf = (link) => window.open(link);

  return props.items.length ? (
    <StyledCard>
      <Table className="table">
        <TableHead>
          <TableRow>
            <TableHeaderCell>Name</TableHeaderCell>
            <TableHeaderCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {props.items.map((o) => (
            <StyledTableRow onClick={() => openPdf(o.link)} key={o.link}>
              <TableCell>{o.name}</TableCell>
              <TableCell align="right">
                <PictureAsPdf style={{ fill: COLOR_NAVY }} />
              </TableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </StyledCard>
  ) : (
    <StyledH2 grey>No content available</StyledH2>
  );
}

Documents.propTypes = propTypes;
export default Documents;
